"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipStyled = exports.TooltipInlineStyle = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _templateObject;
var TooltipStyled = exports.TooltipStyled = (0, _styledComponents["default"])(_reactstrap.UncontrolledTooltip)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .arrow:before {\n    color: '#000';\n    top: 1px !important;\n    background-color: '#fff';\n    border-bottom-color: #fff !important;\n  }\n"])));
var TooltipInlineStyle = exports.TooltipInlineStyle = {
  color: '#000',
  backgroundColor: '#fff'
};